export enum ActivateStreamingBundleOfferTypeEnum {
  BUNDLE = 'Bundle',
  OPTION = 'Option'
}
